// @ts-check
import { Box } from '~/design-system';
import { Trans } from '@lingui/macro';
import { Form, Formik } from 'formik';
import ReadyCheckboxField from '../ReadyCheckboxField';

export default function UpdateStrategyOptions({
  statistics,
  setFormikContext,
  onSubmit,
}) {
  const productRequestStatistics = statistics?.find(
    (stat) => stat.object === 'PRODUCT_REQUEST'
  );
  const initialValues = {
    added: productRequestStatistics?.addedCount > 0,
    updated: productRequestStatistics?.updatedCount > 0,
    unchanged: false,
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(props) => {
        // Map to import-specific flags
        const importOptions = {
          newRequests: props.added,
          updateRequests: props.updated,
        };
        onSubmit(importOptions);
      }}
    >
      {(formikContext) => {
        setFormikContext(formikContext);
        return (
          <Form>
            <Box>
              <Box sx={{ margin: 'auto', width: '330px', textAlign: 'left' }}>
                <ReadyCheckboxField
                  name="added"
                  count={productRequestStatistics?.addedCount}
                  disabled={!initialValues.added}
                >
                  <Trans>Requests will be added</Trans>
                </ReadyCheckboxField>
                <ReadyCheckboxField
                  name="updated"
                  count={productRequestStatistics?.updatedCount}
                  disabled={!initialValues.updated}
                >
                  <Trans>Requests will be updated</Trans>
                </ReadyCheckboxField>
                <ReadyCheckboxField
                  name="unchanged"
                  disabled
                  count={productRequestStatistics?.unchangedCount}
                >
                  <Trans>Requests have no change</Trans>
                </ReadyCheckboxField>
              </Box>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
}
